import { Injectable } from '@angular/core';
import {
	Router, Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot,
	ActivatedRoute
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { BinderWizardService } from '../services/sections/binder/binder-wizard.service';
import { catchError, tap, map } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
@Injectable({
	providedIn: 'root'
})
export class IsBinderAndCustomerLegacy implements Resolve<Observable<boolean>> {
	constructor(
		private router: Router,
		private binderService: BinderWizardService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {
		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.binderService.isBinderAndCustomerLegacy(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
